class CampaignGrid extends HTMLElement {
  constructor() {
    super();
    //this.attachShadow({ mode: 'open' });
  }
  // 1. Tell the browser which attributes to watch closely
  static get observedAttributes() {
    return ['exclude'];
  }

  // 2. Automatically trigger a re-render if the exclude attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'exclude' && oldValue !== newValue) {
      this.render();
    }
  }
  connectedCallback() {
    this.render();
  }

  render() {
    const excludeCampaign = this.getAttribute('exclude');

    const campaigns = [
      {
        id: 'health',
        icon: '🚑',
        title: 'health_care',
        pageUrl: '/health.html',
        desc: 'health_sum',
      },
      {
        id: 'edu',
        icon: '🎓',
        title: 'edu_support',
        pageUrl: '/edu.html',
        desc: 'edu_sum',
      },
      {
        id: 'hunger',
        icon: '🍽️',
        title: 'hunger_relief',
        pageUrl: '/hunger.html',
        desc: 'hunger_sum',
      },
      {
        id: 'disasters',
        icon: '⛈️',
        title: 'disaster_relief',
        pageUrl: '/disasters.html',
        desc: 'disaster_sum',
      },
      {
        id: 'animal',
        icon: '🐾',
        title: 'animal_welfare',
        pageUrl: '/animals.html',
        desc: 'animal_sum',
      },
    ];

    const gridItemHtml = campaigns
      .filter((campaign) => campaign.id !== excludeCampaign)
      .map((campaign) => {
        return `
          <div class="grid-item">
            <div class="campaign-item">
                <div class="icon-box">${campaign.icon}</div>
                <h3 data-i18n="${campaign.title}">${campaign.title}</h3>
            </div>
            <div class="campaign-text">
                <p data-i18n="${campaign.desc}">
                Provide a lifeline to those in need of critical medical care
                through financial assistance and medical resources.
                </p>
            </div>
            <div class="campaign-actions">
                <a
                href="${campaign.pageUrl}"
                data-i18n="learn_more"
                class="btn-secondary read-more"
                >Learn More</a
                >
            </div>
        </div>
        `;
      })
      .join('');

    this.innerHTML = `
    
    <div class="grid-container">
      ${gridItemHtml}
    </div>
        `;
  }
}

customElements.define('campaign-grid', CampaignGrid);
